import React, { useEffect } from "react";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { StudentForm } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { fetchClasses, createStudent } from "../../actions/students";
import { fetchSemesters } from "../../actions/semesters";
import { AppState } from "../../reducers";
import { firestore } from "../../helpers/firebaseHelper";
import Student from "../../Classes/Student";

const PREFIX = "NewStudentContainer";

const classes = {
  paper: `${PREFIX}-paper`,
};

const Root = styled("div")(({ theme }) => ({
  [`& .${classes.paper}`]: {
    padding: theme.spacing(2),
  },
}));

const NewStudentContainer: React.FC = () => {
  const { semester }: { semester: string } = useParams();

  const {
    semesters: { semesters },
    classNames,
  } = useSelector((state: AppState) => {
    return {
      semesters: state.semesters,
      classNames: state.students.classNames,
    };
  });
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchClasses(semester));
    dispatch(fetchSemesters());
  }, [dispatch]);

  const handleSubmit = (values: any) => {
    dispatch(createStudent(values));
  };

  return (
    <Root>
      <Grid container justifyContent="center">
        <Grid item xs={12} md={10}>
          <Paper className={classes.paper}>
            <StudentForm
              saveStudent={handleSubmit}
              semesters={semesters || []}
              initialValues={
                new Student({
                  admissionFeeReceived: false,
                  birthday: new Date(),
                  booksIssued: false,
                  city: "",
                  class: "",
                  clothingBottom: "---",
                  clothingRemark: "",
                  clothingTop: "---",
                  confirmationSent: false,
                  consentSigned: false,
                  contractReceived: false,
                  contractReceivedTimestamp: new Date(),
                  contractSent: false,
                  contractSentDate: new Date(),
                  createdAt: firestore.FieldValue.serverTimestamp(),
                  createdInEconomics: false,
                  createdInSU: false,
                  discharged: false,
                  dischargedDate: null,
                  dischargeReasons: [],
                  email: "",
                  examSubjects: [],
                  firstName: "",
                  gender: "",
                  graduated: false,
                  graduatedDate: null,
                  hasAccount: false,
                  id: firestore().collection("students").doc().id,
                  imageUrl: "",
                  infoLetter: false,
                  interviewer: "",
                  introductionEmail: false,
                  origin: "intra",
                  lastName: "",
                  lectio: false,
                  line: "sport",
                  note: "",
                  phone: "",
                  postcode: "",
                  rate: "",
                  rulesSigned: false,
                  semester: semester,
                  ssn: "",
                  street: "",
                  studentCard: false,
                  subjectsNotPassed: [],
                  userId: null,
                  workExperienceContract: false,
                  workExperienceContract2: false,
                })
              }
              classNames={classNames}
              removeSemester={() => {
                console.log("not implemented");
              }}
              actionsMenu={
                <Button variant="contained" disabled>
                  Handlinger
                </Button>
              }
              // isSaving={false}
            />
          </Paper>
        </Grid>
      </Grid>
    </Root>
  );
};

export default NewStudentContainer;
